import { THEME_COLOR, NAVBAR_BG, SIDEBAR_BG, DIRECTION, DARK_THEME } from '../constants';

// Cargar estado inicial desde localStorage si existe
const loadInitialState = () => {
  try {
    const savedMode = localStorage.getItem('themeMode');
    const savedTheme = localStorage.getItem('themeColor');
    return {
      activeDir: 'ltr',
      activeNavbarBg: '#0b70fb',
      activeSidebarBg: '#ffffff',
      activeMode: savedMode || 'light',
      activeTheme: savedTheme || 'BLUE_THEME',
      SidebarWidth: 240,
    };
  } catch (error) {
    console.error('Error loading theme from localStorage:', error);
    return {
      activeDir: 'ltr',
      activeNavbarBg: '#0b70fb',
      activeSidebarBg: '#ffffff',
      activeMode: 'light',
      activeTheme: 'BLUE_THEME',
      SidebarWidth: 240,
    };
  }
};

const INIT_STATE = loadInitialState();

const CustomizerReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case NAVBAR_BG:
      return {
        ...state,
        activeNavbarBg: action.payload,
      };
    case DARK_THEME:
      // Guardar en localStorage
      try {
        localStorage.setItem('themeMode', action.payload);
      } catch (error) {
        console.error('Error saving theme mode to localStorage:', error);
      }
      return {
        ...state,
        activeMode: action.payload,
      };
    case SIDEBAR_BG:
      return {
        ...state,
        activeSidebarBg: action.payload,
      };
    case THEME_COLOR:
      // Guardar en localStorage
      try {
        localStorage.setItem('themeColor', action.payload);
      } catch (error) {
        console.error('Error saving theme color to localStorage:', error);
      }
      return {
        ...state,
        activeTheme: action.payload,
      };
    case DIRECTION:
      return {
        ...state,
        activeDir: action.payload,
      };

    default:
      return state;
  }
};

export default CustomizerReducer;
